/**
 * Shared URL display helpers. Several components need a compact human label for an
 * outbound URL ("host · /path" or just the host) — this is the canonical home so new
 * call sites stop growing private copies. Never throws: unparseable input falls back
 * to the raw string (values are typically already canonicalized upstream).
 */

/** Hostname without the www. prefix, or the raw input when unparseable. */
export function displayHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Compact link label: "host/first/path" (no trailing slash-only path), or the raw input. */
export function urlLabel(url: string): string {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    const path = u.pathname && u.pathname !== '/' ? u.pathname : '';
    return `${host}${path}`;
  } catch {
    return url;
  }
}
